<form [formGroup]="rentalPropertyReporting">
  <div class="container">
    <div class="form-row">
      <div class="form-col">
        <mat-label class="title-label">Are you using a tax reporting representative ?
        </mat-label>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <mat-radio-group class="primary" formControlName="isUsingTaxRepresentative" aria-label="Select an option"
          required="true" [value]="null">
          <mat-radio-button class="primary" [value]="true" >Yes</mat-radio-button>
          <mat-radio-button class="primary" [value]="false" >No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div *ngIf="showTaxRepresentativeForm" class="row">
      <div class="col-md-6 col-xs-12">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>First name</mat-label>
              <input matInput formControlName="taxRepresentativeFirstName" placeholder="First name" />
              <mat-error> First name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Last name</mat-label>
              <input matInput formControlName="taxRepresentativeLastName" placeholder="Last name" />
              <mat-error>Last name is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Email address</mat-label>
              <input matInput formControlName="taxRepresentativeEmail" placeholder="Email address" />
              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativeEmail')?.errors?.['email'] && (rentalPropertyReporting.get('taxRepresentativeEmail')?.touched)">Email
                address is invalid</mat-error>

              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativeEmail')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativeEmail')?.touched)">Email
                address is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Phone number</mat-label>
              <input matInput appPhoneFormat formControlName="taxRepresentativePhoneNumber" placeholder="Phone number" />
              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.errors?.['pattern'] && (rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.touched)">Phone
                number is invalid</mat-error>

              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.touched)">Phone
                number is required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xs-12">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Tax reporting representative street address</mat-label>
              <input matInput class="form-outline form-control"
                placeholder="Tax reporting representative street address"
                formControlName="taxRepresentativeStreetAddress" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                  (onSelectionChange)="selectPlace(suggestion)">
                  {{ suggestion.description }}
                </mat-option>
              </mat-autocomplete>
              <mat-error>
                Tax reporting representative street address is
                required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Apt/Unit/Suite</mat-label>
              <input matInput formControlName="taxRepresentativeAptUnitSuite" placeholder="Apt/Unit/Suite" />
              <mat-error> Apt/Unit/Suite is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>City</mat-label>
              <input matInput formControlName="taxRepresentativeCity" placeholder="City" />
              <mat-error> City is required</mat-error>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>

              <mat-select formControlName="taxRepresentativeState" placeholder="State">
                @for (state of states; track state) {
                <mat-option [value]="state.id">{{ state.name }}</mat-option>
                }
              </mat-select>
              <mat-error> State is required</mat-error>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="taxRepresentativeZipCode" placeholder="Zip Code" />
              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.errors?.['pattern'] && (rentalPropertyReporting.get('taxRepresentativeZipCode')?.touched)">Zip
                code is invalid</mat-error>

              <mat-error
                *ngIf="this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.errors?.['required'] && (rentalPropertyReporting.get('taxRepresentativeZipCode')?.touched)">Zip
                Code is required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div> 

    <div *ngIf="showTaxRepresentativeForm" class="form-row">
      <mat-label class="title-label">Send all correspondence to</mat-label>
    </div>
    <div *ngIf="showTaxRepresentativeForm" class="form-row">
      <section class="example-section">
        <mat-checkbox class="primary" formControlName="sendToOwner" class="example-margin">Owner</mat-checkbox>
        <mat-checkbox class="primary" formControlName="sendToReportingRep" class="example-margin">Tax reporting
          representative</mat-checkbox>
      </section>
    </div>
    <div *ngIf="showTaxRepresentativeForm && rentalPropertyReporting.errors?.['atLeastOneRequired']"
         class="form-row" style="color:#d32f2f; font-size:12px; padding-left:4px;">
      Select at least one correspondence recipient to continue.
    </div>
   
  </div>
</form>